import styled from 'styled-components';

export const ProjectHealthPageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const ProjectHealthContentSection = styled.div`
	display: flex;
	flex-grow: 1;
`;
